import { render, staticRenderFns } from "./RevisionUpdateModal.vue?vue&type=template&id=725bc44b&scoped=true&"
import script from "./RevisionUpdateModal.vue?vue&type=script&lang=ts&"
export * from "./RevisionUpdateModal.vue?vue&type=script&lang=ts&"
import style0 from "./RevisionUpdateModal.vue?vue&type=style&index=0&id=725bc44b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725bc44b",
  null
  
)

export default component.exports